import { render, staticRenderFns } from "./WatchlistTable.vue?vue&type=template&id=bcff4b0e&"
import script from "./WatchlistTable.vue?vue&type=script&lang=js&"
export * from "./WatchlistTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports